import { Message } from 'types/Messages'

export const asyncSleep = async (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms)
  })

export const safeDecodeURIComponent = (value: string | undefined): string => {
  try {
    return value ? decodeURIComponent(value) : ''
  } catch (error) {
    return value || ''
  }
}

export const headersString = (message: Message) => {
  if (!message) {
    return ''
  }
  return Object.entries(message.headers).reduce((acc, [k, v]) => `${acc}${k}: ${v}\n`, '')
}
